import { ValidationType } from '../enums/validation-type.enum';

export interface ValidationIssue {
  target: string;
  property: string;
  constraints?: string[];
  type: ValidationType;
}
